module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa.fd006f77.jpg";